import { TileImage, pxToRem } from '@archipro-design/aria';
import { getImagesSizes } from '~/utils/image-sizes-utils';
import { useRef } from 'react';
import type { AdvertData } from '@archipro-website/tracker';
import { useAdEventHandler, useTracker } from '@archipro-website/tracker';
import { createLinkedComponentParams } from '~/utils/urlHelper';

interface AdvertBillboardProps {
    title: string;
    carousel: {
        href: string;
        imageDesktop: string;
    }[];
    advertCreative: AdvertData;
}

const ADVERT_BILLBOARD = {
    width: 970,
    height: 250,
};

const AdvertBillboard = ({
    title,
    carousel,
    advertCreative,
}: AdvertBillboardProps) => {
    const ref = useRef(null);
    const { onClick: onAdClick } = useAdEventHandler(advertCreative, ref);
    const tracker = useTracker();

    return (
        <TileImage
            ref={ref}
            height={pxToRem(ADVERT_BILLBOARD.height)}
            width={pxToRem(ADVERT_BILLBOARD.width)}
            images={carousel.map((carousel) => {
                const { imageDesktop, href } = carousel;

                return {
                    alt: title || '',
                    src: imageDesktop,
                    width: ADVERT_BILLBOARD.width,
                    height: ADVERT_BILLBOARD.height,
                    sizes: getImagesSizes(ADVERT_BILLBOARD.width),
                    overlay: {
                        children: <div />,
                        ...createLinkedComponentParams(
                            tracker,
                            'Ad_ImageClick',
                            href,
                            {
                                libraryItemID: advertCreative.professional.id,
                                professionalID: advertCreative.professional.id,
                            },
                            null,
                            onAdClick
                        ),
                        prefetch: 'intent',
                        icon: <div />,
                        alwaysVisible: true,
                        variables: {
                            backgroundColor: 'transparent',
                        },
                    },
                };
            })}
            hideFavourite={true}
            style={{ margin: 'auto' }}
        />
    );
};

export default AdvertBillboard;
